export const a11y = {
  en: {
    close: "Close",
    closeModal: "Close modal",
    closeMenu: "Close menu",
    openMenu: "Open menu",
    closeOverlay: "Close overlay",
    dialog: "Dialog",
    mainMenu: "Main menu",
    mobileMenu: "Mobile menu",
    scrollLeft: "Scroll left",
    scrollRight: "Scroll right",
    selectCountry: "Select country",
    chooseLanguage: "Choose language",
    // {name} = current region label / language name. Trigger buttons for the
    // split region+language market selector.
    regionSelector: "Region: {name}",
    languageSelector: "Language: {name}",
    regionAndLanguageGroup: "Region and language",
    // {name} = store name. Only the trailing word is localized; the brand
    // name is passed through verbatim.
    logoImageAlt: "{name} logo",
    homeLinkAria: "{name} home",
    // About-Us hero image alt. Brand name stays; only the descriptor and
    // separator are localized (DE uses an en dash).
    aboutUsImageAlt: "BÆRSkin Tactical Supply Co. - About Us",
    // {name} = footer/checkout link label that opens a static page in a modal.
    openInModal: "Open {name} in modal",
    // {name} = footer/checkout link label that opens an external URL/new tab.
    openInNewTab: "Open {name} in a new tab",
    openCookiePreferences: "Open cookie preferences",
    // {n} = 1-based slide index.
    goToSlide: "Go to slide {n}",
    openCart: "Open cart",
    // {n} = item count.
    openCartWithCount: "Open cart, {n} items",
    // {name} = option/attribute label (e.g. "color", "size").
    selectPrevious: "Select previous {name}",
    selectNext: "Select next {name}",
    // {name} = product/addon label whose quantity is being adjusted.
    increaseQuantityOf: "Increase quantity of {name}",
    decreaseQuantityOf: "Decrease quantity of {name}",
    // {name} = product/addon label; group wrapping the +/- quantity controls.
    quantityGroup: "{name} quantity",
    // {n} = current quantity in cart (live-region announcement).
    inCart: "{n} in cart",
    // {name} = flag patch name.
    choosePatch: "Choose {name} patch",
    // {n} = 1-based slide index, {total} = total slide count.
    slideNofM: "Slide {n} of {total}",
    // {n} = 1-based slide index.
    slide: "Slide {n}",
    veteransCharitiesAlt: "Veterans charities - supporting our heroes",
    supportingOurHeroesAlt: "Supporting our heroes",
    veteransCharitiesStripAlt: "Veterans charities strip",
    // {n} = 1-based image index in the fullscreen product-carousel modal.
    productModalImage: "Product image {n}",
    // {id} = carousel instance id; region fallback when no explicit label given.
    carousel: "Carousel {id}",
    // Global header search-trigger aria-label (default when none is passed).
    search: "Search",
    // PDP image gallery a11y (cluster 7).
    productPhotos: "Product photos",
    // {n} = 1-based image index, {name} = product name.
    viewLargerImageOf: "View larger image {n} of {name}",
    // {n} = total image count, {name} = product name.
    viewAllImagesOf: "View all {n} images of {name}",
    // {n} = 1-based image index. Alt fallback when media + product name absent.
    productImageIndexed: "Product image {n}",
    // Generic "view larger image" trigger (addon preview).
    viewLargerImage: "View larger image",
    // Mobile color-preview panel.
    closePreview: "Close preview",
    // {color} = selected color name. Alt for the mobile preview thumbnail.
    colorPreview: "{color} preview",
    // Alt fallback for the mobile preview thumbnail when no color is selected.
    productPreview: "Product preview",
    // {name} = addon label. aria-label on the addon selector card.
    selectAddon: "Select {name} addon",
    // Footer a11y (cluster 8). {phone} = phone number.
    callPhone: "Call {phone}",
    footerNavigation: "Footer navigation",
    footerNavigationMobile: "Footer navigation mobile",
    backToHomepage: "← Back to Homepage",
    // {name} = localized colour value (e.g. "Schwarz"). Colour-swatch button.
    colorOption: "Color {name}",
    // appended to an option's aria-label when it is the current selection.
    optionSelected: "selected",
    // appended to an option's aria-label when it is unavailable.
    optionOutOfStock: "out of stock",
    // Top-level site navigation landmark (desktop mega-menu).
    mainNavigation: "Main navigation",
    // {name} = product name, {n} = 1-based image index. Alt for a product
    // gallery image that carries the product name.
    productImageNamed: "{name} image {n}",
    // Alt fallback when neither the media alt nor the product name is present.
    productImage: "Product image",
    // {name} = product name. aria-label on an "add to cart" button.
    addToCart: "Add {name} to cart",
    // {name} = bundle-item / product label. Alt for its thumbnail.
    imageForNamed: "Image for {name}",
    // Live-region announcement when an option is picked:
    // "{attribute} {value} selected" (e.g. "Color Black selected").
    optionAnnouncement: "{label} {value} selected",
    // {rating} = numeric star rating. aria-label on the Trustpilot stars SVG.
    trustpilotStars: "Trustpilot rating: {rating} out of 5 stars",
    // Skip-link that jumps keyboard/AT users past the chrome to main content.
    skipToContent: "Skip to main content",
    // Pagination nav landmark + prev/next control aria-labels.
    paginationNav: "Pagination",
    previousPage: "Previous page",
    nextPage: "Next page",
    // Breadcrumb nav landmark label.
    breadcrumb: "Breadcrumb",
    // Alt for a decorative promotional strip image (no meaningful content).
    promoImageAlt: "Promotional offer",
    // Alt fallback for a recommended/addon product thumbnail with no name.
    recommendedProduct: "Recommended product",
    // Decorative default alts for CMS blocks whose meaning is carried by
    // adjacent text (shown only for broken-image / SEO, dropped from AT tree).
    featureIllustration: "Feature illustration",
    sectionIllustration: "Section illustration",
    featuredContentImage: "Featured content image",
    // {name} = data-driven icon heading. Suffix marks a decorative feature icon.
    iconSuffixOf: "{name} Icon",
    // ContentIconsRow mobile carousel region label. {name} = block headline.
    featureHighlightsOf: "{name} feature highlights",
    featureHighlightsCarousel: "Feature highlights carousel",
    // aria-label fallback for an addon remove button when no product label is
    // available.
    removeAddonFromCart: "Remove addon from cart",
  },
  de: {
    close: "Schließen",
    closeModal: "Dialog schließen",
    closeMenu: "Menü schließen",
    openMenu: "Menü öffnen",
    closeOverlay: "Overlay schließen",
    dialog: "Dialog",
    mainMenu: "Hauptmenü",
    mobileMenu: "Mobiles Menü",
    scrollLeft: "Nach links scrollen",
    scrollRight: "Nach rechts scrollen",
    selectCountry: "Land auswählen",
    chooseLanguage: "Sprache auswählen",
    regionSelector: "Region: {name}",
    languageSelector: "Sprache: {name}",
    regionAndLanguageGroup: "Region und Sprache",
    logoImageAlt: "{name} Logo",
    homeLinkAria: "{name} Startseite",
    aboutUsImageAlt: "BÆRSkin Tactical Supply Co. – Über uns",
    openInModal: "{name} im Dialog öffnen",
    openInNewTab: "{name} in einem neuen Tab öffnen",
    openCookiePreferences: "Cookie-Einstellungen öffnen",
    goToSlide: "Zu Folie {n} springen",
    openCart: "Warenkorb öffnen",
    openCartWithCount: "Warenkorb öffnen, {n} Artikel",
    selectPrevious: "Vorherige(s) {name} auswählen",
    selectNext: "Nächste(s) {name} auswählen",
    increaseQuantityOf: "Menge von {name} erhöhen",
    decreaseQuantityOf: "Menge von {name} verringern",
    quantityGroup: "Menge {name}",
    inCart: "{n} im Warenkorb",
    choosePatch: "Aufnäher {name} auswählen",
    slideNofM: "Folie {n} von {total}",
    slide: "Folie {n}",
    veteransCharitiesAlt:
      "Veteranenhilfswerke – Unterstützung für unsere Helden",
    supportingOurHeroesAlt: "Unterstützung für unsere Helden",
    veteransCharitiesStripAlt: "Veteranenhilfswerke-Leiste",
    productModalImage: "Produktbild {n}",
    carousel: "Karussell {id}",
    search: "Suchen",
    productPhotos: "Produktfotos",
    viewLargerImageOf: "Größeres Bild {n} von {name} ansehen",
    viewAllImagesOf: "Alle {n} Bilder von {name} ansehen",
    productImageIndexed: "Produktbild {n}",
    viewLargerImage: "Größeres Bild ansehen",
    closePreview: "Vorschau schließen",
    colorPreview: "Vorschau: {color}",
    productPreview: "Produktvorschau",
    selectAddon: "{name} als Zusatzartikel auswählen",
    callPhone: "{phone} anrufen",
    footerNavigation: "Fußzeilen-Navigation",
    footerNavigationMobile: "Fußzeilen-Navigation mobil",
    backToHomepage: "← Zurück zur Startseite",
    colorOption: "Farbe {name}",
    optionSelected: "ausgewählt",
    optionOutOfStock: "nicht vorrätig",
    mainNavigation: "Hauptnavigation",
    productImageNamed: "{name} Bild {n}",
    productImage: "Produktbild",
    addToCart: "{name} in den Warenkorb legen",
    imageForNamed: "Bild von {name}",
    optionAnnouncement: "{label} {value} ausgewählt",
    trustpilotStars: "Trustpilot-Bewertung: {rating} von 5 Sternen",
    skipToContent: "Zum Hauptinhalt springen",
    paginationNav: "Seitennummerierung",
    previousPage: "Vorherige Seite",
    nextPage: "Nächste Seite",
    breadcrumb: "Brotkrümelnavigation",
    promoImageAlt: "Sonderangebot",
    recommendedProduct: "Empfohlenes Produkt",
    featureIllustration: "Feature-Illustration",
    sectionIllustration: "Abschnitts-Illustration",
    featuredContentImage: "Hervorgehobenes Inhaltsbild",
    iconSuffixOf: "{name} Symbol",
    featureHighlightsOf: "{name} Feature-Highlights",
    featureHighlightsCarousel: "Feature-Highlights-Karussell",
    removeAddonFromCart: "Zusatzartikel aus dem Warenkorb entfernen",
  },
} as const
